if (!customElements.get('vastra-brand-rail')) {
  customElements.define('vastra-brand-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const track = this.querySelector('[data-rail-track]');
      const controls = this.querySelector('.vbrand-rail__arrows');
      if (!track || !controls) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const buttons = [...controls.querySelectorAll('[data-rail-step]')];
      const update = () => {
        const overflowing = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflowing;
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const advance = (direction) => {
        const card = track.firstElementChild;
        if (!card) return;
        const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        const count = Math.max(1, Math.floor((track.clientWidth + 2) / stride));
        track.scrollBy({ left: direction * stride * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      buttons.forEach(button => button.addEventListener('click', () => advance(Number(button.dataset.railStep)), { signal }));
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        advance(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
}
